<template>
  <div class="row mb-3" v-if="termSuggestions.length >= 1">
    <div class="col-12">
      <p class="mb-1 t-sm t-500">
        Refine your search
        <i class="fa fa-lock t-secondary ml-3" v-if="isLocked" />
        <a
          v-if="sortedTermSuggestions.length > 4"
          class="ml-3" href="#" @click.prevent="toggleViewAll()">Show {{ showAll ? 'less' : 'all' }}</a>
        <a
          @click.stop
          @click.prevent="openTrendsModal"
          href="#"
          class="ml-3"
        >
          See trends
      </a>
      </p>
      <template v-if="showAll">
        <div
          v-for="item in sortedTermSuggestions"
          v-tooltip="!isLocked ? `${item.active ? 'Remove' : 'Add'} this term` : ''"
          :key="item.value"
          class="badge badge-pill is-hover mr-1 badge-primary mb-1"
          :class="{'is-active': item.active}"
          @click.prevent="handleKeywordChanged(item.value)"
        >
          {{ item.value }}
        </div>
      </template>
      <horizontal-list
        v-if="!showAll"
        :items="sortedTermSuggestions"
        hasTrackers
      >
        <template v-slot:default="slotProps">
          <div
            class="badge badge-pill is-hover mr-1 badge-primary"
            :class="{'is-active': slotProps.item.active}"
            @click.prevent="handleKeywordChanged(slotProps.item.value)"
            v-tooltip="!isLocked ? `${slotProps.item.active ? 'Remove' : 'Add'} this term` : ''"
          >
            {{ slotProps.item.value }}
          </div>
        </template>
      </horizontal-list>
    </div>
  </div>
</template>

<script>
import MPService from '@/services/mixpanel'

import HorizontalList from '@/components/shared/HorizontalList'

export default {
  name: 'termSuggestions',
  components: {
    HorizontalList
  },
  props: {
    state: {
      type: Object,
      required: true
    },
    termSuggestions: {
      type: Array,
      required: true
    },
    isScopedSearch: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      showAll: false
    }
  },
  computed: {
    isLocked () {
      return !this.isScopedSearch && !this.$can('useRefineTerms')
    },
    stateTermSuggestions () {
      return !this.isEmpty(this.state.term_suggestions) ? Object.assign([], this.state.term_suggestions) : []
    },
    sortedTermSuggestions () {
      return this.termSuggestions.slice().sort((a, b) => b.active - a.active || b.count - a.count)
    }
  },
  methods: {
    toggleViewAll () {
      MPService.trackEvent('term_suggestions', { type: this.showAll ? 'Show less' : 'Show more' })
      this.showAll = !this.showAll
    },
    openTrendsModal () {
      if (!this.$can('viewTrendsModal')) {
        this.$can.notAllowed()
      } else {
        this.$events.$emit('modal:filter:trends:open', 'refinement_keywords', this.state, 'refinement_keywords')
      }
    },
    handleKeywordChanged (term) {
      if (this.isLocked) {
        this.$can.notAllowed()
        return
      }
      let termSuggestions = this.stateTermSuggestions

      if (termSuggestions.findIndex(termSuggestion => termSuggestion === term) === -1) {
        MPService.trackEvent('term_suggestions', { type: 'Clicked' })
        termSuggestions.push(term)
      } else {
        MPService.trackEvent('term_suggestions', { type: 'Unclicked' })
        termSuggestions = termSuggestions.filter(termSuggestion => termSuggestion !== term)
      }

      this.$emit('termSuggestionChanged', termSuggestions)
    }

  }
}
</script>
